import SeatplanElements from '../../../store/seatplans/elements/index';

angular
    .module('festzelt-os.seatplans')
    .factory('SeatplanElements', [
        '$injector',
        'SeatplanElement',
        ($injector, SeatplanElement) => new SeatplanElements(SeatplanElement, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/store/seatplan_elements.js